import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  constructor() {}

  transform( url: string ): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl( url );
  }
}
